import React from "react";
import { DialogActions } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Button } from "../button/Buttons.js";
import "../button/EditButton.js";
const useClasses = makeStyles()(() => ({
  modalActions: {
    justifyContent: "center"
  }
}));
const ModalButtons = ({ submitButton, cancelButton }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(DialogActions, { className: classes.modalActions }, /* @__PURE__ */ React.createElement(Button, { key: "cancel", label: cancelButton.label, onClick: cancelButton.onClick, "data-testid": "cancelButton" }), /* @__PURE__ */ React.createElement(Button, { key: "submit", color: "primary", label: submitButton.label, onClick: submitButton.onClick, "data-testid": "submitButton" }));
};
export {
  ModalButtons
};
//# sourceMappingURL=ModalButtons.js.map
